import { useFocusEffect } from '@react-navigation/native';

import useConfiguration from 'app/hooks/useConfiguration';
import { isOlderThan, toMs } from 'app/utils/time';

export default function useRefetchConfigOnFocus() {
  const { isFetching, dataUpdatedAt, refetch } = useConfiguration({
    notifyOnChangeProps: ['isFetching', 'dataUpdatedAt', 'refetch'],
  });

  useFocusEffect(() => {
    if (!isFetching && isOlderThan(dataUpdatedAt, toMs(1, 'm'))) {
      refetch();
    }
  });
}
